import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Divider } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '25px',
    margin: '3%',
    marginBottom: '5%',
    '&:hover': {
      boxShadow: '0 3px 5px 2px rgba(0,0,0, .4)'
    },
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0), 0px 1px 1px 0px rgba(0,0,0,0), 0px 1px 3px 0px rgba(0,0,0,0)'
  },
  details: {
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    flex: '1 0 auto',
    textAlign: 'left'
  },
  cover: {
    height: '190px',
    borderRadius: '10px'
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  gap: {
    margin: '4px 0px 2px'
  }
}));

export default function LiquorVendorCard(props) {
  const classes = useStyles();
  let difference;
  var closeHours;
  if (props.vendor.closetime) {
    if (props.vendor.closetime.includes('pm')) {
      var openHours, openMin;
      closeHours = parseInt(
        props.vendor.closetime.substring(0, props.vendor.closetime.indexOf(':'))
      );
      closeHours = closeHours === 12 ? closeHours : closeHours + 12;
      const closeMin = parseInt(
        props.vendor.closetime.substring(
          props.vendor.closetime.indexOf(':') + 1,
          props.vendor.closetime.indexOf(':') + 3
        )
      );
      // const openHours = (parseInt(props.vendor.opentime.substring(0,props.vendor.opentime.indexOf(':')))+12)*60
      // const openMin   = parseInt(props.vendor.opentime.substring(props.vendor.opentime.indexOf(':')+1,props.vendor.opentime.indexOf(':')+3))
      if (props.vendor.opentime.includes('am')) {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? 0 : openHours;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      } else {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? openHours : openHours + 12;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      }
      closeHours *= 60;
      const currentHours = new Date().getHours() * 60;
      const currentMinutes = new Date().getMinutes();

      const today = new Date().getDay().toString();

      if (props.vendor.days && props.vendor.days.indexOf(today) === -1) {
        difference = -1;
      } else if (openHours + openMin === closeHours + closeMin) {
        difference = 1;
      } else if (
        currentHours + currentMinutes > openHours + openMin &&
        currentHours + currentMinutes < closeHours + closeMin
      ) {
        difference = 1;
      } else {
        difference = -1;
      }
    } // if time in A.M.
    else {
      closeHours = parseInt(
        props.vendor.closetime.substring(0, props.vendor.closetime.indexOf(':'))
      );
      closeHours = closeHours === 12 ? 0 : closeHours;
      const closeMin = parseInt(
        props.vendor.closetime.substring(
          props.vendor.closetime.indexOf(':') + 1,
          props.vendor.closetime.indexOf(':') + 3
        )
      );
      const currentHours = new Date().getHours() * 60;
      const currentMinutes = new Date().getMinutes();
      if (props.vendor.opentime.includes('am')) {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? 0 : openHours;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      } else {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? openHours : openHours + 12;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      }

      closeHours *= 60;
      const today = new Date().getDay().toString();

      if (props.vendor.days && props.vendor.days.indexOf(today) === -1) {
        difference = -1;
      }
      if (openHours + openMin === closeHours + closeMin) {
        difference = 1;
      } else if (
        currentHours + currentMinutes > openHours + openMin &&
        currentHours + currentMinutes < closeHours + closeMin
      ) {
        difference = 1;
      } else {
        difference = -1;
      }
    }
  }

  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.cover}
        image={props.vendor.image}
        title="vendor"
      />
      <div className={classes.details}>
        <CardContent
          className={classes.content}
          style={{ paddingBottom: '2px' }}
        >
          <b style={{ textTransform: 'capitalize' }}>{props.vendor.name}</b>
          <div className="container-fluid mt-1 mb-2">
            <div className="row">
              <div className="col-6 pl-0" style={{ textAlign: 'initial' }}>
                <p
                  style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color: 'textSecondary',
                    marginBottom: '0'
                  }}
                >
                  {props.vendor.location}
                </p>
              </div>
              <div className="col-6 pr-0" style={{ textAlign: 'end' }}>
                {props.vendor.distance ? (
                  <p
                    style={{
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      color: 'textSecondary',
                      marginBottom: '0'
                    }}
                  >
                    {(props.vendor.distance + 15).toFixed(2)} mins
                  </p>
                ) : null}
              </div>
            </div>
          </div>
          {/* The Resterayunt Categories code in previous commits */}
          <Divider />
          <div className="container mb-1">
            <div className="row">
              <div className="col-6 pl-0" style={{ textAlign: 'initial' }}>
                <small color="textSecondary" className={classes.gap}>
                  {difference > 0 ? 'Open' : 'Closed'}
                </small>
              </div>
              <div
                className="col-6"
                style={{ textAlign: 'right', padding: '0' }}
              >
                <small color="textSecondary">{props.vendor.distance}KM</small>
              </div>
            </div>
          </div>
        </CardContent>
      </div>
    </Card>
  );
}
